import React from 'react'
import ApplicationInformation from 'components/pages/DetailPage/components/ApplicationFormModalV3/components/ApplicationInformation'
import Payment from 'components/pages/DetailPage/components/ApplicationFormModalV3/components/Payment'
import {
  EApplicationStepsLabel,
  IApplicationStep
} from 'components/pages/DetailPage/components/ApplicationFormModalV3/utils'
import SelectSource from '../../DetailPage/components/ApplicationFormModalV3/components/SelectSource'

export function getNewApplicationSteps(): IApplicationStep[] {
  return [
    {
      label: EApplicationStepsLabel.APPLICATION_INFORMATION,
      content: <ApplicationInformation hasPhoneNumberField={true} />
    },
    { label: EApplicationStepsLabel.PAYMENT, content: <Payment /> },
    { label: EApplicationStepsLabel.COMPLETE_SCREENING, content: <SelectSource /> },
    { label: EApplicationStepsLabel.COMPLETED }
  ]
}
